import { useState, useEffect } from 'react'
import type { Product } from '../../types'
import * as db from '../../services/db'
import { exportProductsToPdf } from '../../services/pdfExport'

export function QRExportView() {
  const [products, setProducts] = useState<Product[]>([])
  const [exporting, setExporting] = useState(false)

  useEffect(() => {
    db.getAllProducts().then(setProducts)
  }, [])

  const handleExport = async () => {
    setExporting(true)
    try {
      await exportProductsToPdf(products, 'kids-grocery-qr-codes.pdf')
    } finally {
      setExporting(false)
    }
  }

  return (
    <>
      <h2 className="page-title">QR Code Export</h2>
      <p style={{ color: 'var(--text-muted)', marginBottom: 24 }}>
        Export all {products.length} products as a printable PDF. Print and tape QR codes on items.
      </p>
      <button
        type="button"
        className="btn-large btn-primary"
        onClick={handleExport}
        disabled={exporting || products.length === 0}
      >
        {exporting ? 'Generating…' : 'Download PDF'}
      </button>
    </>
  )
}
